/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/151-hammer': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.781 12.953l-4.712-4.712a.752.752 0 00-1.061 0l-.354.354L6.779 5.72 11.499 1h-5l-2.22 2.22-.22-.22H2.998v1.061l.22.22-3.22 3.22 2.5 2.5 3.22-3.22 2.875 2.875-.354.354a.752.752 0 000 1.061l4.712 4.712a.752.752 0 001.061 0l1.768-1.768a.752.752 0 000-1.061z"/>'
  }
})
